import {Injectable} from "@angular/core";
import {ExamFormSummaryModel} from "../model/examFormSummary.model";
import {HttpModelConverter} from "../../../core/converter/httpModel.converter";
import {FormSummaryConverter} from "../../../form/form/api/entity/converter/formSummary.converter";

@Injectable()
export class ExamFormSummaryConverter extends HttpModelConverter<ExamFormSummaryModel> {

    constructor(private formSummaryConverter: FormSummaryConverter) {
        super();
    }

    protected createInstance(): ExamFormSummaryModel {
        return new ExamFormSummaryModel();
    }

    protected enrichObject(result: ExamFormSummaryModel, src: ExamFormSummaryModel) {
        result.form = this.formSummaryConverter.convert(src.form);
    }
}